<template>

<el-container class="app-container"
  :class="{
    'mini-side': isCollapse,
    'hide-side': hideSide
  }"
  >
  <el-aside class="app-side" :width="hideSide ? '0' : sideWidth + 'px'"
    :style="{background: theme.theme.backgroundColor}"
    >
    <div class="app-header-logo-box"
      :style="{height: headerHeight + 'px', color: theme.theme.activeTextColor}"
      >
      <img :src="logoImg" alt="" class="header-logo">
    </div>
    <app-side :collapse="isCollapse" :theme="theme.theme"></app-side>
  </el-aside>
  <el-container style="overflow-x: auto">
    <el-header class="app-header" :height="headerHeight + 'px'">
      <app-header @switch="handleSideSwitch" @set-theme="handleSetTheme" @hide-side="handleSwitchHideSide"></app-header>
    </el-header>
    <el-row style="height:50px;border-bottom:2px solid #12AFE3;"><breadcrumd></breadcrumd></el-row>
    <!-- <el-row style="height:50px;"><tags-view></tags-view></el-row> -->
    
    <el-main class="app-body">
      <el-container style="min-height: 100%;overflow: auto" id="appBody">
        <el-main class="app-page-body" style="width:100%;min-height:100%;">
          <router-view></router-view>
        </el-main>
      </el-container>
    </el-main>
  </el-container>
  <m-back-top body-id="appBody"></m-back-top>
  <audio controls="controls" ref="music" preload src="../../static/msg.mp3" hidden></audio>
 
</el-container>


</template>
<script type="text/javascript">
import AppHeader from '@/components/app-header'
import AppFooter from '@/components/app-footer'
import AppSide from '@/components/app-side'
import TagsView from '@/components/TagsView'
import Breadcrumd from '@/components/Breadcrumd'
import { httpURL } from '@/api/http'
import { mapGetters } from 'vuex'
export default {
  name: 'app-view',
  data () {
    return {
      logoImg: '../../static/logo.png',
      isCollapse: false,
      hideSide: false,
      hasMsg: false,
      sideWidth: 200,
      footerHeight: 50,
      headerHeight: 50,
      theme: {theme: {}},
      messageTitle: '',
      messageContent: '',
      user: JSON.parse(sessionStorage.getItem('user'))
    }
  },
  computed: {
    ...mapGetters(['unReadCount'])
  },
  components: {
    AppHeader,
    AppFooter,
    AppSide,
    TagsView,
    Breadcrumd
  },
  created() {
    this.rabbitConnect()
  },
  methods: {
    rabbitConnect() {
      let _this = this;
      var ws = new WebSocket('wss://oa.tianjiare.com:15671/ws');
      // var ws = new WebSocket('ws://42.51.223.66:15674/ws');
      var client = Stomp.over(ws);
      var on_connect = function() {
          // /exchange/user-message-push/user.1 说明
          // exchange 是一个关键字  不用理会
          // user-message-push  代表了一个特定的exchange  这个是可更换的
          // user.* 表示一个key  用户根据该key 连接exchange获取信息 是固定格式的
          client.subscribe("/exchange/user-message-push/user."+_this.user.id, function(d) {
            // 此处编写其他逻辑代码
            // _this.hasMsg = true
            var audio = _this.$refs.music
            audio.play()
            var message = JSON.parse(d.body).content
            _this.$notify.info({
              dangerouslyUseHTMLString: true,
              title: '您有一条新的消息',
              message: message
            })
            _this.$store.dispatch('setUnReadCount')
          })

          client.subscribe("/exchange/system-notification/system-notification", function(d) {
            var audio = _this.$refs.music
            audio.play()
            var message = JSON.parse(d.body).content
            _this.$notify.info({
              dangerouslyUseHTMLString: true,
              title: '您有一条新的消息',
              message: message
            })
            _this.$store.dispatch('setUnReadCount')
          })
          // 可以添加多个client.subscribe
      };
      var on_error =  function() {
        console.log('error')
      };
      client.connect('admin', 'iamceobitch', on_connect, on_error, '/')
    },
    handleSideSwitch (val) {
      this.isCollapse = val
      this.sideWidth = val ? 60 : 200
    },
    handleSwitchHideSide () {
      this.hideSide = !this.hideSide
    },
    handleSetTheme (theme) {
      this.theme = theme
    }
  }
}
</script>
<style type="text/css" scoped>
  .app-container{
    margin: 0 auto;
    position: absolute;
    width: 100%;
    height: 100%;
  }
  .app-container .app-header{
    padding: 0;
    background: #16AAD8;
    overflow: visible;
  }
  .app-container .app-side{
    width: 200px;
    transition: all 0.5s ease;
  }
  .app-container .app-body{
    width:100%;
    height:100%;
    /* background: #ECF0F5; */
    padding:0;
  }
  .app-container .app-footer{
    background: #fff;
    border-top: solid 1px rgba(48, 54, 62, 0.14);
  }
  .app-container .app-page-body{
    width:100%;
    overflow: visible;
    padding: 1px 0 0 2px;
  }
  .app-header-logo-box{
    box-sizing: border-box;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .app-header-logo-box .header-logo{
    height: 42px;
    margin-top:4px;
    margin-left:8px;
    display: block;
  }
  .app-header-logo-box .header-logo-text{
    font-size: 20px;
    font-weight: bold;
    opacity: 1;
  }

  /*mini-side*/
  .app-container.mini-side .app-side{
    overflow: visible;
  }
  .app-container.mini-side .app-side .el-menu--collapse{
    width: 60px;
  }
  /* .app-container.mini-side .header-logo{
    margin-left: -6px;
  } */
  .app-container.mini-side .header-logo-text{
    opacity: 0;
  }
  /*hide-side*/
  .app-container.hide-side .app-side{
    display: none;
  }
  .messageBox{
    padding:10px;
    height:auto;
    background: #333;
    position:fixed;
    right:-220px;
    bottom:0px;
    border: 2px solid #999;
    border-radius: 10px;
    text-align:center;
    transition: 0.5s all ease;
    box-shadow: 0 3px 10px rgba(0, 0, 0, 0.3);
    color:#fff;
  }
  .p0{
    right:8px;
  }
  .messageContent{
    padding:15px;
    font-size:16px;
  }
  .messageClose{
    width:20px;
    height:20px;
    font-size:20px;
    position:absolute;
    right:5px;
    top:0px;
    cursor: pointer;
  }
  /* .messageTitle{
    background: #409EFF;
    padding: 8px;
    color:#fff;
  } */
</style>



// WEBPACK FOOTER //
// src/components/app-view.vue